import { render, staticRenderFns } from "./AlertRedirect.vue?vue&type=template&id=049d423b&"
import script from "./AlertRedirect.vue?vue&type=script&lang=js&"
export * from "./AlertRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports